import React, { useState } from 'react'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import './QuestionBox.css'
export default function QuestionBox(props) {
    const [showAnswer, setShowAnswer] = useState(false)
    return (
        <div className='question-box'>
            <div className='faq-question' onClick={() => setShowAnswer(!showAnswer)}>
                <div className='faq-question-title'>
                    <h3>{props.question}</h3>
                    {
                        showAnswer ? (<MdKeyboardArrowUp />) : (
                            <MdKeyboardArrowDown />
                        )
                    }

                </div>

                {
                    showAnswer ? (
                        <div className='faq-answer'>
                            {props.answer}
                        </div>
                    ) : null
                }

            </div>

        </div>
    )
}
